/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, ReactNode, useRef, useState } from "react";
import useDelayedEffect from "src/hooks/utils/useDelayedEffect";
import { ClickAwayListener } from "@material-ui/core";
import TableCellArrayInput, {
  TableCellArrayInputProps,
} from "./TableCellArrayInput";
import { noop } from "../../../../globalConsts";
import { moreEntriesButtonCss, StyledPopper } from "./styles";

type Props = TableCellArrayInputProps & {
  editable: boolean;
  entriesBtnMessage: string;
};

const Wrapper: FC<Props> = (props) => {
  const [toggled, setToggled] = useState(false);
  const anchorEl = useRef<HTMLButtonElement>(null);

  const {
    values,
    column,
    unformattedValue,
    templateId,
    editable = false,
    format,
    entriesBtnMessage,
    onChange = noop,
  } = props;

  const removeEmptyValuesOnMenuClose = (): void => {
    if (toggled) return;

    const nonEmptyValues = values.filter((cellVal) => cellVal !== -1);
    onChange(nonEmptyValues);
  };

  useDelayedEffect(removeEmptyValuesOnMenuClose, [toggled]);

  return (
    <div style={{ position: "relative" }}>
      <button
        type="button"
        ref={anchorEl}
        css={moreEntriesButtonCss}
        onClick={(): void => setToggled((prevState) => !prevState)}
      >
        {entriesBtnMessage}
      </button>
      <StyledPopper
        open={toggled}
        anchorEl={anchorEl.current}
        role={undefined}
        placement="bottom"
      >
        <ClickAwayListener onClickAway={(): void => setToggled(false)}>
          {/* ten div tam je proto, protoze ten clickAwayListener potrebuje na neco namapovat ref */}
          <div>
            <TableCellArrayInput
              values={values}
              onChange={onChange}
              column={column}
              unformattedValue={unformattedValue}
              format={format}
              templateId={templateId}
              disabled={!editable}
              allowEdit
              allowInsert
            />
          </div>
        </ClickAwayListener>
      </StyledPopper>
    </div>
  );
};

export default Wrapper;
